<mat-accordion class="audit-log-accordion" *ngIf="recordId">
  <mat-expansion-panel (opened)="ensureLoaded()">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon class="panel-icon">history</mat-icon>
        Audit History
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div *ngIf="loading" class="loading-state">Loading...</div>
    <div *ngIf="!loading && dataSource.data.length === 0" class="empty-state">No changes recorded.</div>

    <div class="mat-table-container" *ngIf="!loading && dataSource.data.length > 0">
      <mat-form-field appearance="outline" class="filter-field">
        <mat-label>Search</mat-label>
        <input matInput type="text" (keyup)="doFilter($event)" placeholder="Filter audit logs">
      </mat-form-field>

      <table mat-table [dataSource]="dataSource" class="mat-elevation-z1">
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>Log #</th>
          <td mat-cell *matCellDef="let r">{{ r.id }}</td>
        </ng-container>

        <ng-container matColumnDef="changed_at">
          <th mat-header-cell *matHeaderCellDef>Time</th>
          <td mat-cell *matCellDef="let r">{{ r.changed_at | date:'dd MMM yyyy, h:mm a':'Asia/Kolkata' }}</td>
        </ng-container>

        <ng-container matColumnDef="operation">
          <th mat-header-cell *matHeaderCellDef>Op</th>
          <td mat-cell *matCellDef="let r">
            <span [ngClass]="r.operation" class="op-badge">{{ r.operation }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="field">
          <th mat-header-cell *matHeaderCellDef>Field</th>
          <td mat-cell *matCellDef="let r">{{ displayField(r.field) }}</td>
        </ng-container>

        <ng-container matColumnDef="oldValue">
          <th mat-header-cell *matHeaderCellDef>Old</th>
          <td mat-cell *matCellDef="let r">{{ formattedCell(r, 'old') }}</td>
        </ng-container>

        <ng-container matColumnDef="newValue">
          <th mat-header-cell *matHeaderCellDef>New</th>
          <td mat-cell *matCellDef="let r">{{ formattedCell(r, 'new') }}</td>
        </ng-container>

        <ng-container matColumnDef="created_by">
          <th mat-header-cell *matHeaderCellDef>By</th>
          <td mat-cell *matCellDef="let r">{{ r?.created_by_label || r?.created_by || '' }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons></mat-paginator>
    </div>
  </mat-expansion-panel>
</mat-accordion>
